var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLine10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 13,
    viewBox: "0 0 68 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1.00004C14.1941 1.77048 45.8658 2.84909 67 1.00003",
    stroke: "#0033AD",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0083 1.99043C35.0083 3.72942 11.5852 7.39255 4.11349 7.60387C-5.22613 7.86802 33.433 7.60389 51.5231 7.60387C69.4908 7.60384 46.4531 9.51873 26.8844 11.0376",
    stroke: "#0033AD",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine10);
export default __webpack_public_path__ + "static/media/Line 10.5728a9090a4cb30f2a1c1da7ba4d79f8.svg";
export { ForwardRef as ReactComponent };